<script lang="ts">
import { lateinit } from 'tg-commons'
import { ControlPosition, unwrapStringEnumValue, type BaseMap, type WrapStringEnumValue, type ZoomControl, type ZoomControlOptions } from 'tg-map-core'
import { defineComponent, watch } from 'vue'
import { createEmptyVNode, optionalProp, stringEnumProp, type Props } from '../../utils/vue-utils'
import { useTgMapInner } from '../map-hooks'

export default defineComponent({
  name: 'tg-zoom-control',
  props: {
    position: stringEnumProp(ControlPosition, ControlPosition.RIGHT_BOTTOM),
    showZoomLevel: optionalProp(Boolean),
  } satisfies Props<WrapStringEnumValue<ZoomControlOptions, {
    position: typeof ControlPosition,
  }>>,
  setup(props) {
    let control = lateinit<ZoomControl>()

    const { map, onCreate, onDestroy } = useTgMapInner<BaseMap>()

    onCreate(() => {
      control = map.createZoomControl(unwrapStringEnumValue(props))
      map.addControl(control)
    })

    onDestroy(() => {
      map.removeControl(control)
    })

    watch(() => props.position, (value) => {
      control.setPosition(unwrapStringEnumValue(value, ControlPosition))
    })
    watch(() => props.showZoomLevel, (value) => {
      control.setShowZoomLevel(value ?? true)
    })
    return createEmptyVNode
  },
})
</script>
